import { render } from "./menu-application.vue?vue&type=template&id=0760070a&scoped=true"
import script from "./menu-application.vue?vue&type=script&lang=js"
export * from "./menu-application.vue?vue&type=script&lang=js"

import "./menu-application.vue?vue&type=style&index=0&id=0760070a&scoped=true&lang=css"

import exportComponent from "E:\\SonPhat\\Project\\QLBX_WEB\\CauHinhHoaDonDienTu_FE\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0760070a"]])

export default __exports__